let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bhXC1")).then(() => parcelRequire('aRHS7'));